
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"opacity":".7","x":".5","y":".5","width":"29","height":"29","rx":"4.5","fill":"#fff","stroke":"#C7C7C7"}}),_c('path',{attrs:{"d":"M14.036 9.745a.969.969 0 00-1.409 1.33l3.7 3.925-3.7 3.925a.969.969 0 001.41 1.33l4.314-4.568a1 1 0 000-1.374l-4.315-4.568z","fill":"#9B9B9B"}})])
          )
        }
      }
    